<template>
    <div name="rankings" class="rankings">
        <toast 
            v-if="isToast"
            @close="isToastClose"
        />
        <post
            v-if="isPost"
            @onClose="closePost"
            @onSubmit="submitUncomfortable"
        />
        <ranking-banner 
            @postUncomfortable="postUncomfortable"
        />
        <div class="layout">
            <count-info 
                :count="vocPage.allCount"
            />
            <div class="list-layout">
                <sort-button 
                    @change="typeChange"
                />
               <list style="margin-top: 20px;" 
                    @login="loginWithoutPost"
                    @like="likeSubmit"
               />
            </div>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex'
import List from '@/components/organisms/pc_uncomfortable/List';
import CountInfo from '@/components/molecules/pc_uncomfortable/CountInfo';
import NavigationBar from '@/components/molecules/pc_uncomfortable/NavigationBar';
import RankingBanner from '@/components/organisms/pc_uncomfortable/RankingBanner';
import SortButton from '@/components/molecules/pc_uncomfortable/SortButton';
import Cookie from '@/utilities/cookie';
import CampaignAuth from '@/utilities/campaignAuth';
import Post from '@/components/organisms/pc_uncomfortable/Post'
import Toast from '@/components/molecules/pc_uncomfortable/Toast';
import axios from 'axios';

export default {
    name: 'rankings',
    computed: mapState(['vocPage', 'vocDiabetes', 'vocLoginKakaoToken']),
    components: { List, CountInfo, NavigationBar, RankingBanner, SortButton, Post, Toast },
    data: function()
    {
        return {
            curPage: 1,
            totalCount: 0,
            pageCount: 1000,
            isPost: false,
            isToast: false,
            type: 'createdAt'
        }
    },
    mounted: function()
    {
        // load voc diabetes page 

        this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
            .then((res) => {
                this.totalCount = this.vocPage.totalcount;
            })
            .catch((err) => {

            })

        this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: CampaignAuth.getToken()});

        if(this.$route.query.ispost === "true")
        {
            this.$router.push('/campaign/ranking');
            this.isPost = true;
            // post open
        }
    },
    methods: {
        typeChange: function(type)
        {
            this.type = type;
            this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                .then((res) => {
                    this.totalCount = this.vocPage.totalcount;
                })
                .catch((err) => {

                })
        },
        postUncomfortable: function()
        {

            const token = CampaignAuth.getToken()
            this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: token});
            if(token === null)
            {
                this.login();
            }
            else
            {
                //open 
                this.isPost = true;
            }
            // 유효한 카카오 토큰이 있는지 확인

        },
        login: function()
        {
            CampaignAuth.login(`/campaign/ranking?ispost=true`);
        },
        loginWithoutPost: function()
        {
            CampaignAuth.login(`/campaign/ranking`);
        },
        likeSubmit: function(id)
        {
            this.$store.commit(Constant.INITIALIZE_DIABETES_VOC)
            this.vocDiabetes.id = id;
            this.$store.dispatch(Constant.UPDATE_DIABETES_VOC)
                .then((res) => {
                    this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                        .then((res) => {
                            this.totalCount = this.vocPage.totalcount;
                        })
                        .catch((err) => {

                        })

                    // like local storage 처리
                    let likedata = JSON.parse(Cookie.getLocalStorageWithExpire("voclike"));
                    if(likedata === null)
                    {
                        likedata = {};
                    }
                    Cookie.updateOrAddValue(likedata, this.vocLoginKakaoToken, id);
                    Cookie.setLocalStorageWithExpire("voclike", JSON.stringify(likedata))
                    this.isToast = true;

                    //isToast 
                })
                .catch((err) => {

                })
        },
        isToastClose: function()
        {
            this.isToast = false;
        },
        closePost: function()
        {
            this.isPost = false;
        },
        submitUncomfortable: function(yearCount, contents)
        {
            this.$store.dispatch(Constant.FETCH_DIABETES_VOC_PAGE, {pageno: this.curPage, pagesize: this.pageCount, sort: this.type})
                .then((res) => {
                    this.totalCount = this.vocPage.totalcount;
                })
                .catch((err) => {

                })


            this.isPost = false;

        }
    }
}
</script>

<style scoped>
    .rankings {
        width: 100%;
        background: #212529;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .layout {
        display: flex;
        width: 1296px;
        padding-top: 113px;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 72px;
        min-height: 300px;
    }
    .list-layout {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
    }
</style>    


// WEBPACK FOOTER //
// src/page/pc_uncomfortable/Rankings.vue